module.exports = __webpack_public_path__ + "svg/payment-way2.svg?816a58529fdf70dc4aec8612bef7376b";